<div *ngIf="listaCuentas && listaCuentas.length > 0" class="flex flex-col gap-4 p-4">
  <div *ngFor="let cuenta of listaCuentas">
    <app-working-account-card [cuenta]="cuenta" (deleteAccount)="eliminarCuenta()" (actualizarCuenta)="actualizar($event)"  ></app-working-account-card>
  </div>
</div>
